module.exports = __webpack_public_path__ + "media/flat/visa-f627cb1c.svg";